import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              The Algorithmic Consistency Initiative
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              Leading research on AI safety frameworks and policy development
            </p>
          </div>

          {/* Research */}
          <div>
            <h4 className="font-bold text-lg mb-4">Research</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/whitepaper" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  The Mirror Effect
                </Link>
              </li>
              <li>
                <Link to="/constitutional-ai" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  The Algorithmic Consistency Initiative
                </Link>
              </li>
              <li>
                <Link to="/ai-liability" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  AI Liability Framework
                </Link>
              </li>
              <li>
                <Link to="/state-of-ai" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  State of AI Report
                </Link>
              </li>
              <li>
                <Link to="/get-book" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer font-semibold">
                  📚 Get the Book
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-bold text-lg mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/publications" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  All Publications
                </Link>
              </li>
              <li>
                <Link to="/infographics" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  Infographics
                </Link>
              </li>
              <li>
                <Link to="/media-kit" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  Media Kit
                </Link>
              </li>
              <li>
                <Link to="/analytics-dashboard" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  Analytics Dashboard
                </Link>
              </li>
              <li>
                <a href="/rss.xml" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer flex items-center gap-2">
                  <i className="ri-rss-line"></i>
                  RSS Feed
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-bold text-lg mb-4">Connect</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <a href="/#contact" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  Contact
                </a>
              </li>
              <li>
                <a href="mailto:research@algorithmicconsistency.org" className="text-slate-400 hover:text-white transition-colors duration-300 text-sm cursor-pointer">
                  research@algorithmicconsistency.org
                </a>
              </li>
            </ul>
            
            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-800 hover:bg-red-800 transition-colors duration-300 rounded-lg cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-800 hover:bg-red-800 transition-colors duration-300 rounded-lg cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-slate-800 hover:bg-red-800 transition-colors duration-300 rounded-lg cursor-pointer">
                <i className="ri-github-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © 2025 The Algorithmic Consistency Initiative. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-slate-400 hover:text-white text-sm transition-colors duration-300 cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}